import Vue from 'vue'
import Router from 'vue-router'
import Profile from '@/components/Doctor/Profile'
import Login from '@/components/Login'
import MFASettings from '@/components/MFASettings'
import MfaAccountSettings from '@/components/Doctor/MfaAccountSettings'
import MfaOTPConfirmationScreen from '@/components/Doctor/MfaOTPConfirmationScreen'
import ResetPassword from '@/components/ResetPassword'
import Home from '@/components/Home'
import Logout from '@/components/Logout'
import Mer from '@/components/Mer/Mer'
import Appointments from '@/components/Appointments/Appointments'
// import PreEmployees from '@/components/PreEmployees/PreEmployees'
import AdminHome from '@/components/Admin/AdminHome'
import ably from '../core/ably'

Vue.use(Router)
// Vue.use(Buefy)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/mfa-otp',
      name: 'MFA-OTP',
      component: MfaOTPConfirmationScreen
    },
    {
      path: '/mfa-settings',
      name: 'MFA',
      component: MFASettings
    },
    {
      path: '/profile/mfa-account-settings',
      name: 'MFASettings',
      component: MfaAccountSettings
    },
    {
      path: '/resetPassword/:token',
      name: 'resetPassword',
      component: ResetPassword
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/admin-home',
      name: 'adminHome',
      component: AdminHome
    },
    {
      path: '/mer',
      name: 'mer',
      component: Mer
    },
    {
      path: '/appointments',
      name: 'appointments',
      component: Appointments
    }
    // {
    //   path: '/pre-employees',
    //   name: 'pre-employees',
    //   component: PreEmployees
    // }
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['login', 'Login', 'resetPassword', 'MFA', 'MFA-OTP']
  const authRequired = !publicPages.includes(to.name)
  var loggedIn = false
  var isAdmin = false
  if (sessionStorage.getItem('isLoggedIn')) {
    loggedIn = JSON.parse(sessionStorage.getItem('isLoggedIn'))
  }
  if (sessionStorage.getItem('isAdmin')) {
    isAdmin = JSON.parse(sessionStorage.getItem('isAdmin'))
  }
  if (authRequired && !loggedIn) {
    ably.close()
    sessionStorage.clear()
    return next('login')
  } else if (!authRequired && loggedIn) {
    if (isAdmin) {
      return next('admin-home')
    }
    return next('home')
  } else if (authRequired && loggedIn) {
    const adminPaths = ['/admin-home']
    if (isAdmin) {
      const canAccess = adminPaths.includes(to.path)
      if (!canAccess) {
        return next('admin-home')
      }
    } else {
      const cantAccess = adminPaths.includes(to.path)
      if (cantAccess) {
        return next('home')
      }
    }
  }
  next()
})

// Vue.http.interceptors.push((req, next) => {
//   req.headers.set('X-DOCTOR-KEY', sessionStorage.getItem('X-DOCTOR-KEY'))
//   next(res => {
//     if (res.status === 401) {
//       ably.close()
//       sessionStorage.clear()
//       return next('/login')
//     } else if (res.status === 200) {
//       return next('/home')
//     }
//   })
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js